import React, { useEffect, useState } from 'react';
import { Button, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faEdit, faFileAlt } from '@fortawesome/free-solid-svg-icons';

//Components
import MainCard from '../../../../../components/MainCard';
import TextField from '../../../../../components/TextField';
import RichTextEditor from '../../../../../components/RichTextEditor';
import TabelaListagemFichas from '../../../../../components/TabelaListagemFichas/TabelaListagemFichas';
import ModalCustomized from '../../../../../components/Modal/Modal';

//Api
import modelosEmail_api from '../../../../../api/modelosEmail_api';
import variaveisSistema_api from '../../../../../api/variaveisSistema_api';

//Helpers
import { showMessage } from '../../../../../helpers/message';
import { validarCampos, objCampo } from '../../../../../helpers/ValidadorDeCampos';
import { getSessionCookie } from '../../../../../helpers/cookies';

//Context
import { useAuth } from '../../../../../context/auth';

function initialStateModeloEmail(secretaria_id) {
    return {
        identificacao: "",
        conteudo: "",
        status: "Ativo",
        assunto: "",
        secretaria_Id: secretaria_id,
        imagensConteudo: []
    }
}
export default function CadastroModeloEmail({ id, btnVoltar, editavel = false }) {
    //Dados de autenticação
    const session = getSessionCookie();

    //Estado de controle dos campos de erro
    const [errors, setErrors] = useState({});

    //Estado de controle dos campos de cadastro de modelo de email
    const [modeloEmail, setModeloEmail] = useState(initialStateModeloEmail(session.secretaria_Id));


    //State de lista de Variaveis do sistema
    const [listaVariaveisSistema, setListaVariaveisSistema] = useState([]);

    //State para visibilidade do modal
    const [isModalListaVariaveis, setIsModalListaVariaveis] = useState(false);

    const toggleModalListaVariaveis = () => setIsModalListaVariaveis(!isModalListaVariaveis);

    const { setLoading, loading } = useAuth();

    //Estado de controle dos campos obrigatorios 
    const campos = [
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "status", required: true }),
        objCampo({ name: "conteudo", required: true }),
        objCampo({ name: "assunto", required: true }),
    ];

    //Função de load do modelo de email para atualização
    const loadModeloEmail = (id = null) => {
        if (id != null || modeloEmail.id != null) {
            setLoading(true);
            modelosEmail_api.getItem(modeloEmail?.id ?? id).then(response => {
                response.data.imagensConteudo = [];
                setModeloEmail(response.data);
            }).catch(e => showMessage("Erro", e.message, "error", null))
                .finally(f => setLoading(false));
        }
    }

    const loadListaVariaveisSistema = () => {
        setLoading(true)
        variaveisSistema_api.getList().then(response => {
            setListaVariaveisSistema(response.data);
        })
            .catch(e => showMessage("Erro", e.message, "error", null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadModeloEmail(id);
        loadListaVariaveisSistema();
    }, []);


    //Função de onChange dos campos de cadastro
    const onChange = (e) => {
        const { name, value } = e.target;
        const _modeloEmail = {
            ...modeloEmail,
            [name]: value
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_modeloEmail, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setModeloEmail(_modeloEmail);
    }

    const setImage = (base64, e) => {
        setModeloEmail(anterior => ({
            ...anterior,
            [e.target.name]: e.target.value,
            imagensConteudo: [...anterior.imagensConteudo ?? [], base64]
        }));
    }

    //Função para dar submit nos dados do modelo de email
    const onSubmit = () => {
        //Realizando a validação dos campos obrigatorios
        const _errors = validarCampos(modeloEmail, campos);
        setErrors(_errors[0])

        if (_errors[1].length > 0)
            return;

        //Realizando o cadastro/edição do modelo de email
        const _modeloEmail = { ...modeloEmail };
        setLoading(true);
        if (modeloEmail.id) {
            modelosEmail_api.put(_modeloEmail).then(response => {
                showMessage("Sucesso", "Sucesso ao atualizar o modelo de e-mail!", "success", btnVoltar);
            })
                .catch(err => showMessage("Erro", err.message, "error", null))
                .finally(() => setLoading(false));
        } else {
            modelosEmail_api.post(_modeloEmail).then(response => {
                showMessage("Sucesso", "Sucesso ao cadastrar o modelo de e-mail!", "success", btnVoltar);
            })
                .catch(err => showMessage("Erro", err.message, "error", null))
                .finally(() => setLoading(false));
        }
    }

    //Cabeçalhos que a tabela terá
    const headersListaDeVariaveis = [
        { value: "Código", objectValue: "codigo", align: "left" },
        { value: "Descrição", objectValue: "descricao", align: "left" }
    ];

    return (
        <>
            <Button onClick={btnVoltar} className='px-4'><FontAwesomeIcon icon={faAngleLeft} className='me-2' /> Voltar</Button>
            <MainCard>
                <Row className='d-flex align-items-center justify-content-between mb-4'>
                    <Col md="6" lg="6" className='text-start'>
                        <h5 className='text-secondary'>Adicionar modelo de e-mail</h5>
                    </Col>
                    <Col md="6" lg="6" className={`text-end ${editavel ? "" : "d-none"}`}>
                        <Button
                            color='dark'
                            className='text-white fw-bold'
                            onClick={() => setIsModalListaVariaveis(true)}
                        >
                            <FontAwesomeIcon icon={faFileAlt} />  Visualizar lista de variáveis
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="5">
                        <TextField
                            label="* Identificação"
                            name={"identificacao"}
                            onChange={onChange}
                            value={modeloEmail.identificacao}
                            invalid={!!errors.identificacao}
                            maxLength={50}
                            disabled={modeloEmail.identificacao == "Recuperação de Senha" || modeloEmail.identificacao == "Cadastro de Usuário" || !editavel}
                        />
                    </Col>
                    <Col md="12" lg="5">
                        <TextField
                            label="* Assunto"
                            name={"assunto"}
                            onChange={onChange}
                            value={modeloEmail.assunto}
                            invalid={!!errors.assunto}
                            maxLength={100}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="2">
                        <TextField
                            type={"select"}
                            label="* Status"
                            name={"status"}
                            options={
                                [
                                    { label: "Ativo", value: "Ativo" },
                                    { value: "Inativo", label: "Inativo" }
                                ]
                            }
                            onChange={onChange}
                            value={modeloEmail.status}
                            invalid={!!errors.status}
                            disabled={modeloEmail.identificacao == "Recuperação de Senha" || modeloEmail.identificacao == "Cadastro de Usuário" || !editavel}
                        />
                    </Col>
                </Row>
                <Row>
                    {isModalListaVariaveis &&
                        <ModalCustomized
                            toggle={toggleModalListaVariaveis}
                            isOpen={isModalListaVariaveis}
                            btnClose={toggleModalListaVariaveis}
                            title={"Lista de variáveis"}
                        >
                            <TabelaListagemFichas
                                options={{ print: false, search: true, pagination: true }}
                                headers={headersListaDeVariaveis}
                                items={listaVariaveisSistema.filter(v => ((modeloEmail.identificacao == "Recuperação de Senha" || modeloEmail.identificacao == "Cadastro de Usuário") && v.tipo == "Cadastro de Usuário") ||
                                    (modeloEmail.identificacao != "Recuperação de Senha" && modeloEmail.identificacao != "Cadastro de Usuário" && v.tipo == "Infração"))
                                }
                            />
                        </ModalCustomized>}
                </Row>
                <Row className='mt-2'>
                    <Col md="12" lg="12">
                        {((id && modeloEmail.conteudo != "") || (!id)) &&
                            < RichTextEditor
                                name={"conteudo"}
                                saveImage={setImage}
                                value={modeloEmail.conteudo}
                                onChange={onChange}
                                invalid={!!errors.conteudo}
                            />
                        }
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="12" className={`d-flex align-items-center justify-content-center mt-4 ${editavel ? "" : "d-none"}`}>
                        <Button className='px-4' color={id ? 'warning text-white' : 'success'} onClick={onSubmit}>{id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}</Button>
                    </Col>
                </Row>
            </MainCard>
        </>
    );
}